import {
  createUniComponentFromWebComponent,
  type DataViewWidgetProps,
} from '../../core/index.js';
import {
  type CompactLeadingViewItem,
  DataViewHeaderViews,
} from './views-view.js';

export const widgetViewsBar = createUniComponentFromWebComponent<
  DataViewWidgetProps & {
    activateCurrentViewOnClick?: boolean;
    compact?: boolean;
    compactLeadingItem?: CompactLeadingViewItem;
    onChangeView?: (viewId: string) => void;
    openOptionsOnActiveViewClick?: boolean;
    selectedViewId?: string | null;
  }
>(DataViewHeaderViews);
